import { sendErrorMetric } from "@expert/cloudwatch-metrics";

/**
 * `component` label scoping core's whole-workspace `RenderCrash` alert. Like any `component` value it must be listed
 * in expert-workspace-api's `SUPPORTED_COMPONENTS`, or the collector drops it (see `trackedBoundaryProps`).
 */
const WORKSPACE_SHELL_COMPONENT = "workspace-shell";

/** `root` is the router's last-resort boundary; `workspace` is the one inside the softphone, around the workspace. */
export type WorkspaceShellBoundary = "root" | "workspace";

/** Emit one `RenderCrash` per caught crash; call it from `onError` or an effect, never from a render. */
export function emitWorkspaceShellCrash(boundary: WorkspaceShellBoundary): void {
    void sendErrorMetric("RenderCrash", { component: WORKSPACE_SHELL_COMPONENT, action: boundary });
}
